import { useEffect, useState } from "react";
import {
  MANAGE_COLLECTIONS_API,
  MANAGE_ITEM_API,
} from "../../../../../../Utilities/APIs/APIs";
import useAxiosInstance from "../../../../../../Utilities/Hooks/useAxiosInstance";
import Form from "../../../../../Partials/Layouts/Forms/Form";
import SelectInput from "../../../../../Partials/Layouts/Forms/FormInputs/SelectInput/SelectInput";
import SelectOption from "../../../../../Partials/Layouts/Forms/FormInputs/SelectInput/SelectOption/SelectOption";
import FormSubmitButton from "../../../../../Partials/Layouts/Forms/FormSubmitButton/FormSubmitButton";

function CreateItemCollections({
  employee,
  setShowCreateForm,
  setShowModal,
  triggerFetch,
}) {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [product, setProduct] = useState("");
  const [collections, setCollections] = useState([]);

  const axiosInstance = useAxiosInstance();

  useEffect(() => {
    async function fetchCollections() {
      try {
        const response = await axiosInstance.get(MANAGE_ITEM_API);
        if (response && response.data) {
          setCollections(response.data.collections);
        }
      } catch (error) {
        console.error("Error fetching collections: ", error);
      }
    }

    fetchCollections();
  }, [axiosInstance]);

  async function handleSubmit(e) {
    e.preventDefault();
    const itemData = { name, description };

    try {
      const response = await axiosInstance.post(
        MANAGE_COLLECTIONS_API,
        itemData
      );

      if (response) {
        setShowCreateForm(false);
        setShowModal(false);
        triggerFetch();
      }
    } catch (error) {
      console.error("Error creating collection: ", error);
    }
  }
  return (
    <div className="crate_form">
      <Form onSubmit={handleSubmit}>
        <SelectInput label={"Product"} value={product} setState={setProduct}>
          <SelectOption optionValue="" optionText="Select Product" />
          {collections?.map((collection) => (
            <SelectOption
              key={collection._id}
              optionValue={collection._id}
              optionText={collection.name}
            />
          ))}
        </SelectInput>
        <FormSubmitButton text="Add Product" />
      </Form>
    </div>
  );
}

export default CreateItemCollections;
